export default __webpack_public_path__ + "static/media/Blood of the Damned.c90fd7f2.jpg";